var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2364,
    height: 1046,
    transform: "translate(-192 -409)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 22.0003C9.68664 22.0003 7.44466 21.1984 5.65626 19.7308C3.86786 18.2632 2.64372 16.2205 2.19227 13.9515C1.74082 11.6825 2.08999 9.3278 3.18043 7.28741C4.27087 5.24702 6.03506 3.64753 8.17237 2.76202C10.3097 1.87651 12.688 1.75864 14.902 2.42999C17.1159 3.10134 19.0286 4.52021 20.3141 6.44366C21.5996 8.36711 22.1785 10.6764 21.952 12.9788C21.7256 15.2812 20.7078 17.4345 19.0722 19.0706C17.1961 20.9456 14.6525 21.9991 12.0001 22.0003V22.0003ZM7.75209 10.1468C7.62181 10.1468 7.49286 10.1727 7.37269 10.223C7.25252 10.2733 7.14358 10.347 7.05214 10.4398C6.8666 10.6214 6.75896 10.8677 6.75209 11.1273V11.1624C6.75819 11.423 6.86589 11.6714 7.05214 11.8538L10.4612 15.262C10.5534 15.3561 10.6633 15.4298 10.7847 15.4808C10.9061 15.5318 11.0364 15.5589 11.1681 15.5589C11.2998 15.5589 11.4301 15.5318 11.5515 15.4808C11.6729 15.4298 11.783 15.3561 11.8751 15.262L16.9931 10.1448C17.0845 10.0552 17.1575 9.9483 17.2074 9.83038C17.2574 9.71246 17.2834 9.58539 17.2841 9.45733V9.42218C17.2823 9.16242 17.1776 8.91355 16.9931 8.73077C16.8083 8.55157 16.5633 8.44778 16.306 8.43975H16.2662C16.0092 8.44854 15.7644 8.55222 15.5792 8.73077L11.1681 13.1429L8.46815 10.4437C8.37418 10.3491 8.26223 10.2736 8.13893 10.223C8.01562 10.1723 7.88343 10.1476 7.75013 10.1487L7.75209 10.1468Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSelect);
export default __webpack_public_path__ + "static/media/icon-select.12a6177207760c60a051ae60bdb5a576.svg";
export { ForwardRef as ReactComponent };